import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// httpOnly `session_token` cookie is the sole auth mechanism now (was
// duplicated in localStorage until Feb 2026). `withCredentials: true`
// tells axios to include the cookie on cross-origin requests, which is
// required because the frontend and backend live on separate subdomains
// through Emergent's ingress. Backend CORS already has
// `allow_credentials=True` + a reflective origin regex to match.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Auto-logout on 401 (session purged/expired) and 403 (owner-allowlist
// reject). Bounces to /login; for 403 we forward `?reason=access_denied`
// so the Login page can render the amber "workspace is private" banner.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    // Don't clobber login-flow errors — AuthCallback + Login handle their own.
    const isAuthFlow = url.includes("/auth/session")
      || url.includes("/auth/dev-login")
      || url.includes("/auth/pwa-transfer");
    if ((status === 401 || status === 403) && !isAuthFlow) {
      if (typeof window !== "undefined"
          && !window.location.pathname.startsWith("/login")
          && !window.location.pathname.startsWith("/auth/callback")) {
        const suffix = status === 403 ? "?error=exchange_failed&reason=access_denied" : "";
        window.location.replace(`/login${suffix}`);
      }
    }
    return Promise.reject(error);
  },
);

export function fmtMoney(n, opts = {}) {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  const abs = Math.abs(n);
  const sign = n < 0 ? "−" : opts.showPositive && n > 0 ? "+" : "";
  const formatted = abs.toLocaleString("en-IN", {
    minimumFractionDigits: opts.decimals ?? 2,
    maximumFractionDigits: opts.decimals ?? 2,
  });
  return `${sign}₹${formatted}`;
}

export function fmtNum(n, decimals = 2) {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return Number(n).toLocaleString("en-IN", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function fmtPct(n, decimals = 2) {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return `${(n * 100).toFixed(decimals)}%`;
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      dateStyle: "short",
      timeStyle: "medium",
    });
  } catch (e) {
    return String(iso);
  }
}

export function fmtTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString("en-IN", {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  } catch (e) {
    return String(iso);
  }
}
